import(/* webpackMode: "eager" */ "/codebuild/output/src4184552055/src/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppProviders"] */ "/codebuild/output/src4184552055/src/src/app/providers.tsx");
